
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;

    // Calculate range of pages to show
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (endPage - startPage < 4) {
        if (startPage === 1) {
            endPage = Math.min(totalPages, startPage + 4);
        } else {
            startPage = Math.max(1, endPage - 4);
        }
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    return (
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
            <div className="dataTables_info" role="status" aria-live="polite">
                Página {currentPage} de {totalPages}
            </div>
            <div className="dataTables_paginate paging_simple_numbers">
                <ul className="pagination mb-0">
                    <li className={`paginate_button page-item previous ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                        </button>
                    </li>

                    {startPage > 1 && (
                        <>
                            <li className="paginate_button page-item">
                                <button className="page-link" onClick={() => onPageChange(1)}>1</button>
                            </li>
                            {startPage > 2 && <li className="paginate_button page-item disabled"><span className="page-link">...</span></li>}
                        </>
                    )}

                    {pages.map(page => (
                        <li key={page} className={`paginate_button page-item ${currentPage === page ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => onPageChange(page)}>
                                {page}
                            </button>
                        </li>
                    ))}

                    {endPage < totalPages && (
                        <>
                            {endPage < totalPages - 1 && <li className="paginate_button page-item disabled"><span className="page-link">...</span></li>}
                            <li className="paginate_button page-item">
                                <button className="page-link" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                            </li>
                        </>
                    )}

                    <li className={`paginate_button page-item next ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Pagination;
